import { EventBus } from "@/core/utilities/event-bus.js"

export default {
    data: () => {
        return {
            nextChapterLink: false,
            previousChapterLink: false,

            currentChapterIndex: false,
            currentKeyframeIndex: false,
            currentPresentationIndex: false,
            currentSlideIndex: false,

            currentChapterUri: false,
            currentKeyframeUri: false,
            currentPresentationUri: false,
            currentSlideUri: false,

            currentRoute: false,
            currentTitle: false,

            nextRoute: false,
            nextTitle: false,

            previousRoute: false,
            previousTitle: false,

            hotKeysLinks: ['z', 'x', 'c', 'v', 'b', 'n', 'm']
        }
    },
    props: {
        navigationData: {
            type: Object,
            required: true
        },
        structure: {
            type: Object,
            required: true
        }
    },
    computed: {
        links() {
            let links = []
            if (this.currentChapter) links = links.concat(...this.currentChapter.links)
            if (this.currentSlide) links = links.concat(...this.currentSlide.links)
            if (this.currentKeyframe) links = links.concat(...this.currentKeyframe.links)

            links = links.reverse()
            links.map((link, index) => {
                if (!link.hotKey) link.hotKey = this.hotKeysLinks[index] || false
            })
            links = links.reverse()

            return links
        },
        presentations() {
            return this.structure.presentations
        },
        overlays() {
            return this.structure.overlays
        },
        currentPresentation() {
            return this.presentations[this.currentPresentationIndex]
        },
        currentChapter() {
            if (this.currentPresentation) {
                return this.currentPresentation.chapters[this.currentChapterIndex]
            }
            return false
        },
        currentSlide() {
            if (this.currentChapter) {
                return this.currentChapter.slides[this.currentSlideIndex]
            }
            return false
        },
        currentKeyframe() {
            if (this.currentSlide) {
                return this.currentSlide.keyframes[this.currentKeyframeIndex]
            }
            return false
        },
        navigationStart() {
            return !this.previousRoute.name
        },
        navigationEnd() {
            return !this.nextRoute.name
        },
        currentChapters() {
            return this.currentPresentation.chapters
        },
        currentVisibleChapters() {
            return this.currentChapters.filter(c => !c.hideFromMenu)
        },
        currentSlides() {
            return this.currentChapter.slides
        },
        currentVisibleSlides() {
            return this.currentSlides.filter(s => !s.hideFromMenu)
        }
    },
    methods: {
        onNavigation(data) {
            this.nextChapterLink = data.nextChapterLink,
            this.previousChapterLink = data.previousChapterLink,

            this.currentChapterIndex = data.currentChapterIndex,
            this.currentKeyframeIndex = data.currentKeyframeIndex,
            this.currentPresentationIndex = data.currentPresentationIndex,
            this.currentSlideIndex = data.currentSlideIndex,

            this.currentChapterUri = data.currentChapterUri,
            this.currentKeyframeUri = data.currentKeyframeUri,
            this.currentPresentationUri = data.currentPresentationUri,
            this.currentSlideUri = data.currentSlideUri,

            this.currentRoute = data.currentRoute,
            this.currentTitle = data.currentTitle,

            this.nextRoute = data.nextRoute,
            this.nextTitle = data.nextTitle,

            this.previousRoute = data.previousRoute,
            this.previousTitle = data.previousTitle
        },
        getRoute(to = {}) {

            let route = {name: "root", params: {}}

            if (to.keyframe) {
                route.name = "keyframe"
                route.params.keyframe = to.keyframe
                route.params.slide = to.slide || this.currentSlideUri
                route.params.chapter = to.chapter || this.currentChapterUri
                route.params.presentation = to.presentation || this.currentPresentationUri
                return route
            }

            if (to.slide) {
                route.name = "slide"
                route.params.slide = to.slide
                route.params.chapter = to.chapter || this.currentChapterUri
                route.params.presentation = to.presentation || this.currentPresentationUri
                return route
            }

            if (to.chapter) {
                route.name = "chapter"
                route.params.chapter = to.chapter
                route.params.presentation = to.presentation || this.currentPresentationUri
                return route
            }

            if (to.presentation) {
                route.name = "presentation"
                route.params.presentation = to.presentation
                return route
            }

            return route
        },
        getRouteTitle(route = {}) {
            let presentation = false
            let chapter = false
            let slide = false
            let keyframe = false
            let overlay = false

            if (!route) return false

            if (route.query) {
                overlay = this.overlays.find(o => o.uri === route.query.overlay)
                if (overlay) return overlay.title
            }

            presentation = this.presentations.find(p => p.uri === route.params.presentation)

            if (!presentation) return false
            if (route.name === "presentation") return presentation.title

            if (!presentation.chapters || !presentation.chapters.length) return false
            chapter = presentation.chapters.find(c => c.uri === route.params.chapter)

            if (!chapter) return false
            if (route.name === "chapter") return chapter.title

            if (!chapter.slides || !chapter.slides.length) return false
            slide = chapter.slides.find(s => s.uri === route.params.slide)

            if (!slide) return false
            if (route.name === "slide") return slide.title

            if (!slide.keyframes || !slide.keyframes.length) return false
            keyframe = slide.keyframes.find(k => k.uri === route.params.keyframe)

            if (!keyframe) return false
            if (route.name === "keyframe") return keyframe.title
        }
    },
    created() {
        EventBus.$on('navigationEvent', this.onNavigation)
        this.onNavigation(this.navigationData)
    },
    destroyed() {
        EventBus.$off('navigationEvent', this.onNavigation)
    }
}